<template>
  <d-tabs v-model="selectedGroup" ref="tabs" class="groups-tab">
    <d-tab :title="group.name" class="p-3" v-for="(group, index) in model" :key="index">
      <d-row>
        <!-- Nome -->
        <d-col md="8" class="form-group">
          <label for="name">
            Etiqueta
          </label>
          <d-form-input
            type="text"
            id="fename"
            placeholder="Nome"
            v-model="group.name"
            :state="hasError(group, 'name')"
          />
          <d-form-invalid-feedback>Etiqueta é obrigatório</d-form-invalid-feedback>
        </d-col>
        <d-col md="4" class="form-group text-right d-flex justify-content-end align-items-end">
          <label class="d-block p-2"></label>
          <d-button-group class="buttons">
            <d-button type="button" size="sm" class="btn-success" @click.prevent="addTab()">
              <i class="fas fa-plus"></i><span class="d-none d-lg-inline"> Adicionar Aba</span>
            </d-button>
            <d-button type="button" size="sm" class="btn-secondary" @click.prevent="duplicateTab(index)">
              <i class="fas fa-copy"></i><span class="d-none d-lg-inline"> Duplicar Aba</span>
            </d-button>
            <d-button type="button" size="sm" class="btn-danger" @click.prevent="confirmDeleteTab(index)">
              <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Deletar Aba</span>
            </d-button>
          </d-button-group>
        </d-col>
      </d-row>

      <!-- Product Table -->
      <d-form-row class="mt-4 mb-4 justify-content-end">
        <table class="table table-striped table-bordered" role="table">
          <thead class="bg-light" role="rowgroup">
            <tr role="row">
              <th role="columnheader" class="text-center">ID</th>
              <th role="columnheader">Descrição produto</th>
              <th role="columnheader">Garantia</th>
              <th role="columnheader" class="text-center">Unid.</th>
              <th role="columnheader" class="text-center">Qtd.</th>
              <th role="columnheader" class="text-right">Valor un.</th>
              <th role="columnheader" class="text-right">Total</th>
              <th role="columnheader" class="text-right"></th>
            </tr>
          </thead>
          <draggable
            v-model="group.rows"
            tag="tbody"
            ghost-class="ghost"
            draggable=".draggable-item"
            @end="setProductInAutocomplete"
          >
            <tr
              role="row"
              v-for="(item, navItemId) in group.rows"
              :key="navItemId"
              class="drag-row draggable-item"
            >
              <td role="cell" class="td-1">
                <span class="d-block mt-2 text-center">{{navItemId + 1}}</span>
              </td>
              <td role="cell" class="td-4">
                <autocomplete
                  :ref="`autocompleteProduct_${index}${navItemId}`"
                  :state="state"
                  placeholder="Produto"
                  :items="products"
                  item-show="name"
                  :parameter="{item, index}"
                  :on-input="(name) => onInputProduct(name, activePriceTable)"
                  :on-select="setProductQuotationRow"
                  :on-blur="setDescriptionQuotationRow"
                ></autocomplete>
                <d-form-invalid-feedback>Pelo menos um produto é obrigatório</d-form-invalid-feedback>
              </td>
              <td role="cell" class="td-3">
                <InputWarranty :warranty.sync="item.warranty_period" :warrantyTypeId.sync="item.warranty_type"/>
              </td>
              <td role="cell" class="td-2">
                <d-select
                  v-model="item.unit_type"
                  :options="productUnits"
                  value-field="name"
                  text-field="name"
                  @change="changeStep(item)"
                >
                </d-select>
              </td>
              <td role="cell" class="td-2">
                <input
                  type="number"
                  class="text-center form-control"
                  :step="item.step"
                  placeholder="Qtd."
                  v-model="item.quantity"
                  @change="setTotal(item, index)"
                  required
                />
              </td>
              <td role="cell" class="td-3">
                <d-input-group prepend="R$">
                  <input-currency
                    model-index="value"
                    placeholder="Valor"
                    :parameter="index"
                    :model="item"
                    :on-change="setTotal"
                  ></input-currency>
                </d-input-group>
              </td>
              <td role="cell" class="td-3">
                <d-input-group prepend="R$">
                  <input-currency
                    model-index="total"
                    placeholder="Total"
                    :parameter="index"
                    :model="item"
                    :on-change="setUnitValor"
                  ></input-currency>
                </d-input-group>
              </td>
              <td role="cell" class="td-1 buttons">
                <i class="fas fa-minus text-danger" @click="removeRow(index, navItemId)" v-if="group.rows.length > 1"></i>
              </td>
            </tr>
          </draggable>
        </table>
        <button type="button" @click="addRow(index)" class="btn btn-success"><i class="fas fa-plus text-white"></i> Novo item</button>
      </d-form-row>

      <d-form-row class="justify-content-end">

        <!-- Subtotal -->
        <d-col md="12" lg="4" xl="2" cols="12" class="form-group">
          <label for="feSubtotal">Subtotal</label>
          <d-input-group prepend="R$">
            <input-currency
              model-index="subtotal"
              placeholder="Subotal"
              :parameter="index"
              :model="group"
              :on-change="setUnitValor"
              readonly
            ></input-currency>
          </d-input-group>
        </d-col>

        <!-- Desconto -->
        <d-col md="12" lg="4" xl="2" cols="12" class="form-group mb-0">
          <label for="feDesconto">Desconto</label>
          <d-input-group class="mb-3 discount">
            <d-input-group-addon prepend>
              <select class="input-group-text form-control custom-select" v-model="group.discount_type" @change="setQuotationTotal(null, index)">
                <option value="pct" selected>%</option>
                <option value="value">R$</option>
              </select>
            </d-input-group-addon>
            <input-currency
              model-index="discount"
              placeholder="Desconto"
              hiddenGroup=""
              :parameter="index"
              :model="group"
              :on-change="setQuotationTotal"
            ></input-currency>
          </d-input-group>
        </d-col>

        <!-- Total -->
        <d-col md="12" lg="4" xl="2" cols="12" class="form-group">
          <label for="feTotal">Total</label>
          <d-input-group prepend="R$">
            <input-currency
              model-index="total"
              placeholder="Total"
              :parameter="index"
              :model="group"
              :on-change="setQuotationDiscount"
              :state="hasError(group, 'total')"
            ></input-currency>
            <d-form-invalid-feedback>Total é obrigatório</d-form-invalid-feedback>
          </d-input-group>
        </d-col>

      </d-form-row>

      <!-- Show payment spot-->
      <d-form-row class="justify-content-end">
        <d-col cols="6" class="form-group text-rigth">
          <d-form-row  class="justify-content-end">
            <label class="mr-3">Exibir pagamento à vista parcelado</label>
            <d-checkbox toggle @change="togglePaymentSpot(index)" :checked="group.payment_spot == 1" class="custom-toggle-sm mr-2">Sim</d-checkbox>
          </d-form-row>
        </d-col>
      </d-form-row>

      <!-- If payment has spot payment_type -->
      <d-form-row class="justify-content-end" v-if="group.payment_spot == 1 && group.installments_by_types.spot">
        <d-col lg="9" xl="7" cols="12" class="form-group">
          <d-card class="pb-2">
            <d-card-header>
              <h6 class="m-0">Valor à vista parcelado</h6>
            </d-card-header>
            <d-form-row class="px-3 justify-content-end">
              <!-- Quantidade de parcelas -->
              <d-col md="3" cols="12" class="form-group mb-0">
                <label for="feEntree">Entrada</label>
                <d-input-group class="mb-2 discount">
                  <d-input-group-addon prepend>
                    <select
                      class="input-group-text form-control custom-select"
                      v-model="group.installments_by_types.spot[0].entree_type"
                      @change="setParcelValue(group.installments_by_types.spot, index)"
                    >
                      <option value="pct" selected>%</option>
                      <option value="value">R$</option>
                    </select>
                  </d-input-group-addon>
                  <input-currency
                    model-index="entree_value"
                    placeholder="Entrada"
                    hiddenGroup=""
                    :parameter="0"
                    :model="group.installments_by_types.spot[0]"
                    :on-change="setParcelValue"
                  ></input-currency>
                </d-input-group>
              </d-col>

              <!-- Quantidade de parcelas -->
              <d-col md="2" cols="12" class="form-group mb-0">
                <label for="fePagto">Parcelas</label>
                <d-form-input
                  type="number"
                  id="fePagto"
                  class="text-right"
                  min="1"
                  v-model="group.installments_by_types.spot[0].parcel"
                  @change="setParcelValue(group.installments_by_types.spot[0], index)"
                />
              </d-col>

              <!-- Valor da parcela -->
              <d-col md="3" cols="12" class="form-group mb-0">
                <label for="feParcela">Valor da parcela</label>
                <d-input-group prepend="R$">
                  <input-currency
                    v-if="group.installments_by_types.spot && group.installments_by_types.spot[0] && group.installments_by_types.spot[0].parcel_value"
                    model-index="parcel_value"
                    placeholder="R$ 0,00"
                    :model="group.installments_by_types.spot[0]"
                    readonly
                  ></input-currency>
                </d-input-group>
              </d-col>

              <!-- Total -->
              <d-col md="4" cols="12" class="form-group d-flex flex-column">
                <label for="feParcela">Total</label>
                <div class="form-control text-right">{{ addCurrencyMask(group.installments_by_types.spot[0].total) }}</div>
              </d-col>
            </d-form-row>
          </d-card>
        </d-col>
      </d-form-row>

      <!-- If payment type is 7 = "à prazo" -->
      <d-form-row class="justify-content-end" v-if="group.payment_id == 7">
        <d-col lg="9" xl="7" cols="12" class="form-group">
          <d-card class="pb-2">
            <d-card-header>
              <h6 class="m-0">Valores à prazo</h6>
            </d-card-header>
            <d-form-row class="px-3 justify-content-end" v-for="(payment, payment_index) in group.installments_by_types.forward" :key="payment_index">
              <!-- Quantidade de parcelas -->
              <d-col md="3" cols="12" class="form-group mb-0">
                <label for="feEntree">Entrada</label>
                <d-input-group class="mb-2 discount">
                  <d-input-group-addon prepend>
                    <select class="input-group-text form-control custom-select" v-model="payment.entree_type" @change="setParcelValue(payment, index)">
                      <option value="pct" selected>%</option>
                      <option value="value">R$</option>
                    </select>
                  </d-input-group-addon>
                  <input-currency
                    model-index="entree_value"
                    placeholder="Entrada"
                    hiddenGroup=""
                    :parameter="index"
                    :model="payment"
                    :on-change="setParcelValue"
                  ></input-currency>
                </d-input-group>
              </d-col>

              <!-- Quantidade de parcelas -->
              <d-col md="2" cols="12" class="form-group mb-0">
                <label for="fePagto">Parcelas</label>
                <d-form-input type="number" id="fePagto" class="text-right" min="1" v-model="payment.parcel" @change="setParcelValue(payment, index)"/>
              </d-col>

              <!-- Valor da parcela -->
              <d-col md="3" cols="10" class="form-group mb-0">
                <label for="feParcela">Valor da parcela</label>
                <d-input-group prepend="R$">
                  <input-currency
                    v-if="payment.parcel_value"
                    model-index="parcel_value"
                    placeholder="R$ 0,00"
                    :model="payment"
                    readonly
                  ></input-currency>
                </d-input-group>
              </d-col>

              <!-- Total -->
              <d-col md="3" cols="10" class="form-group d-flex flex-column">
                <label for="feParcela">Total</label>
                <div class="form-control text-right">{{ addCurrencyMask(payment.total) }}</div>
              </d-col>

              <d-col md="1" cols="2">
                <div class="d-flex justify-content-end align-items-center h-100 pt-4">
                  <i class="fas fa-plus text-success mr-2" @click="addInstallment(index)" v-if="showAddNewInstallment(group.installments_by_types.forward, payment_index)"></i>
                  <i class="fas fa-minus text-danger" @click="removeInstallment(index, payment_index)" v-if="group.installments_by_types.forward.length > 1"></i>
                </div>
              </d-col>
            </d-form-row>
          </d-card>
        </d-col>
      </d-form-row>

      <d-form-row class="justify-content-end">

        <!-- Condição de pagamento -->
        <d-col md="6" lg="6" xl="2" cols="12" class="form-group">
          <label for="fePagto">Cond. pagamento</label>
          <d-select v-model="group.payment_id" @change="calcSubtotal(index)">
            <option :value="option.id" v-for="(option, index) in paymentTypeOptions" :key="index">{{ option.name }}</option>
          </d-select>
        </d-col>

        <!-- Forma de pagamento -->
        <d-col md="12" lg="12" xl="4" cols="12" class="form-group">
          <label for="fePagtoInfo">Forma de pagamento</label>
          <textarea
            v-model="group.payment_info"
            name="feComentarios"
            rows="5"
            class="form-control"
          ></textarea>
        </d-col>
      </d-form-row>

      <!-- Shipping Company -->
      <d-form-row>

        <d-col md="6" lg="6" xl="2" cols="12" class="form-group">
          <label for="feShippingCOmpany">Transportadora</label>
          <d-form-input type="text" id="feShippingCOmpany" v-model="group.shipping_company" />
        </d-col>

        <!-- Weight -->
        <d-col md="6" lg="6" xl="2" cols="12" class="form-group">
          <label for="feWeight">Peso</label>
          <d-form-input type="text" id="feWeight" class="text-right" min="1" v-model="group.weight" />
        </d-col>

        <!-- Voume -->
        <d-col md="6" lg="6" xl="2" cols="12" class="form-group">
          <label for="feVolume">Volume</label>
          <d-form-input type="text" id="feVolume" class="text-right" min="1" v-model="group.volume" />
        </d-col>

      </d-form-row>

      <d-form-row>

        <!-- Comentários -->
        <d-col md="6" lg="6" cols="12" class="form-group">
          <label for="feComentarios" class="d-flex justify-content-between">
            Obrigações contratante
            <button v-if="!group.obligations_buyer" @click="openObligation('contractor', index)" type="button" class="btn-primary btn-sm py-1 btn-sm">Obrigações Contratante</button>
          </label>
          <editor :model.sync="group.obligations_buyer" />
        </d-col>

        <!-- Obrigações -->
        <d-col md="6" lg="6" cols="12" class="form-group">
          <label for="feObligations" class="d-flex justify-content-between">
            Obrigações contratado
            <button v-if="!group.obligations_seller" @click="openObligation('hired', index)" type="button" class="btn-primary btn-sm py-1 btn-sm">Obrigações Contratado</button>
          </label>
          <editor :model.sync="group.obligations_seller"/>
        </d-col>

      </d-form-row>

      <d-form-row>
        <!-- Itens Inclusos -->
        <d-col cols="12" class="form-group">
          <label for="feComentarios" class="d-flex justify-content-between">
            Itens Inclusos
            <button v-if="!group.items_included" @click="openObligation('itemsIncluded', index)" type="button" class="btn-primary btn-sm py-1 btn-sm">Itens Inclusos</button>
          </label>
          <editor :model.sync="group.items_included" />
        </d-col>
      </d-form-row>

    </d-tab>
  </d-tabs>
</template>

<script>
import draggable from 'vuedraggable';
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Editor from '_shared/Editor.vue';
import Events from '_utils/events';
import Autocomplete from '_shared/Autocomplete.vue';
import CurrencyMask from '_common/mixins/CurrencyMask';
import InputCurrency from '_shared/InputCurrency.vue';
import InputWarranty from '_shared/InputWarranty.vue';
import MixinValidateForm from '_common/mixins/ValidateForm';
import MixinQuotationCalc from '_common/mixins/QuotationCalc';
import GroupActions from './GroupActions.js';
import {
  ROW,
  GROUP,
  PAYMENT,
  PAYMENT_TYPE_OPTIONS,
  PRODUCT_UNITS_OPTIONS,
  _DELETE_TAB_,
  _LOAD_MODEL_,
  _OPEN_OBLIGATION_MODAL_,
  _SET_OBLIGATION_IN_QUOTATION_,
  MODEL,
  PAYMENT_SPOT,
} from './QuotationModel';

export default {
  name: 'group-form',
  mixins: [MixinQuotationCalc, MixinValidateForm, CurrencyMask, GroupActions],
  components: {
    Editor,
    draggable,
    Autocomplete,
    InputCurrency,
    InputWarranty,
  },
  props: {
    groups: {
      type: Array,
      default() { return [cloneDeep(GROUP)]; },
    },
    state: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedGroup: 0,
      autoCapitalize: false,
      template: null,
      errors: {
        name: { required: false },
        total: { required: false },
      },
    };
  },
  computed: {
    paymentTypeOptions() {
      return PAYMENT_TYPE_OPTIONS;
    },
    activePriceTable() {
      const { quotation } = this.$store.state.quotation;
      return quotation.service.price_table;
    },
    products() {
      const { productVariationsList } = this.$store.state.product;
      if (productVariationsList && productVariationsList.list.length) {
        return productVariationsList.list;
      }
      return [];
    },
    quotation() {
      const { quotation } = this.$store.state.quotation;
      if (quotation) return quotation;
      return cloneDeep(MODEL);
    },
    productUnits() {
      const { productUnits } = this.$store.state.product;
      if (productUnits && productUnits.length) {
        return productUnits;
      }
      return PRODUCT_UNITS_OPTIONS;
    },
    model: {
      get() {
        return this.groups;
      },
      set(value) {
        this.$emit('update:groups', value);
      },
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getTypeOptions',
      'getProductUnits',
      'getProductVariations',
      'getPaymentTypeOptions',
    ]),
    addRow(index) {
      this.addGroupRow(ROW, index);
      setTimeout(() => {
        this.calcSubtotal(index);
      }, 50);
    },
    checkRequiredFields() {
      let valid = true;
      this.model.forEach(group => {
        Object.keys(group.errors).forEach(field => {
          group.errors[field].required = (group[field] == null);
          valid = group.errors[field].required === true ? false : valid;
        });
        return group;
      });
      return valid;
    },
    addInstallment(index) {
      if (this.model[index].installments_by_types.forward.length < 3) {
        this.model[index].installments_by_types.forward.push(cloneDeep(PAYMENT));
      }
    },
    addTab() {
      this.addGroupTab(GROUP, 'Novo orçamento');
    },
    changeStep(item) {
      item.step = 1;
      setTimeout(() => {
        if (item.unit_type === 'm²') {
          item.step = 0.01;
          return item;
        }
        return item;
      }, 50);
    },
    getOptions() {
      if (!this.$store.state.quotation.productUnits) {
        this.setToggle({ type: 'progress', bool: true });
        this.getProductUnits()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
      this.getObligationOptions();
    },
    removeRow(groupIndex, index) {
      this.removeGroupRow(groupIndex, index);
      setTimeout(() => {
        this.calcSubtotal(groupIndex);
        this.setProductInAutocomplete();
      }, 50);
    },
    removeInstallment(groupIndex, index) {
      this.model[groupIndex].installments_by_types.forward.splice(index, 1);
    },
    setProductInAutocomplete() {
      setTimeout(() => {
        this.model.map((group, index) => (
          group.rows.map((product, navItemId) => {
            if (this.$refs[`autocompleteProduct_${index}${navItemId}`][0] && product.description) {
              this.$refs[`autocompleteProduct_${index}${navItemId}`][0].$refs.input.value = product.description;
            }
            return product;
          })
        ));
      }, 20);
    },
    setDescriptionQuotationRow(value, { item }) {
      if (item.variation_id === null) {
        item.description = value;
      }
    },
    setProductQuotationRow(product, { item, index }) {
      item.description = product.name;
      item.warranty_period = product.warranty_period;
      item.warranty_type = product.warranty_type;
      item.variation_id = product.id;
      item.value = product.price;
      item.unit_type = product.unit_type;
      this.setTotal(item, index);
    },
    showAddNewInstallment(installments, index) {
      const { length } = installments;
      if (length < 3 && index + 1 === length) {
        return true;
      }
      return false;
    },
    openObligation(type, index) {
      this.setToggle({ type: 'add_obligations_modal', bool: true });
      Events.$emit(_OPEN_OBLIGATION_MODAL_, { type, index });
    },
    togglePaymentSpot(index) {
      this.model[index].payment_spot = this.model[index].payment_spot === 1 ? 0 : 1;
      this.model[index].installments_by_types = {
        ...this.model[index].installments_by_types,
        ...{
          spot: [cloneDeep(PAYMENT_SPOT)],
        },
      };
      this.setQuotationTotal(null, index);
    },
    recalculateAfterTemplateApply() {
      this.model.forEach((group, index) => {
        this.calcSubtotal(index);
        this.setPortionValue(index);
      });
      this.updateTabs();
      this.setProductInAutocomplete();
    },
  },
  destroyed() {
    Events.$off(_LOAD_MODEL_);
    Events.$off(_DELETE_TAB_);
    Events.$off(_SET_OBLIGATION_IN_QUOTATION_);
  },
  mounted() {
    this.getOptions();
    this.loadModel();
    Events.$on(_LOAD_MODEL_, () => {
      this.loadModel();
    });
    Events.$on(_DELETE_TAB_, index => {
      this.deleteTab(index);
    });
    Events.$on(_SET_OBLIGATION_IN_QUOTATION_, ({ obligation, type, index }) => {
      const field = { contractor: 'obligations_buyer', hired: 'obligations_seller', itemsIncluded: 'items_included' };
      this.model[index][field[type]] = obligation;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  cursor: pointer;
  color: $primary;
  font-size: 0.7rem;
  margin-left: 10px;
  &:hover {
    text-decoration: underline;
  }
}
.groups-tab /deep/ .nav-tabs {
  border-bottom: 0!important;
}
.tab-pane {
  border: 1px solid #e1e5eb;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
}

.td {
  &-1 {
    width: 4%;
  }
  &-2 {
    width: 10%;
    min-width: 75px;
  }
  &-3 {
    width: 15%;
  }
  &-4 {
    width: 35%;
  }
}
.buttons {
  text-align: center;
  vertical-align: bottom;
  .btn-sm { padding: 0.4rem 0.7rem; }
  i { cursor: pointer; }
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

@media only screen
  and (max-width: 760px), (min-device-width: 768px)
  and (max-device-width: 1024px)  {

  /* Force table to not be like tables anymore */
  table, thead, tbody, th, td, tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  tr {
    margin: 0;
    &:nth-child(odd) {
      background: #ccc;
    }
  }

  td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    vertical-align: middle;
    padding-top: 30px;
    &:first-child {
      text-align: center;
      padding: 3px 3px 9px 3px;
      &:before {
        position: absolute;
        top: 10px;
        left: 116px;
        width: 5%;
        padding-right: 10px;
        white-space: nowrap;
      }
    }
    &:before {
      /* Now like a table header */
      position: absolute;
      /* Top/left values mimic padding */
      top: 5px;
      left: 6px;
      width: 5%;
      padding-right: 10px;
      white-space: nowrap;
    }
    &.td-1,
    &.td-2,
    &.td-3,
    &.td-4 {
      width: 100%;
    }
    &.buttons {
      i {
        padding: 10px;
        color: #fff !important;
        border-radius: 5px;
        &.fa-minus{
          border: 1px solid #c4183c;
          background: #dc3545;
        }
        &.fa-plus {
          margin-right: 5px;
          border: 1px solid #28a745;
          background: #17c671;
        }

      }
    }
  }

  /*
  Label the data
  You could also use a data-* attribute and content for this. That way "bloats" the HTML, this way means you need to keep HTML and CSS in sync. Lea Verou has a clever way to handle with text-shadow.
  */
  td:nth-of-type(1):before { content: "ID"; }
  td:nth-of-type(2):before { content: "Descrição produto"; }
  td:nth-of-type(3):before { content: "Garantia"; }
  td:nth-of-type(4):before { content: "Unid."; }
  td:nth-of-type(5):before { content: "Qtd."; }
  td:nth-of-type(6):before { content: "Valor un."; }
  td:nth-of-type(7):before { content: "Total"; }
  td:nth-of-type(8):before { content: "Op\00e7\00f5""es"; }
}

</style>
